
import { Button } from 'element-ui';
import LoginForm from '@/pages/authenticate/components/LoginForm.vue';
import SocialLoginBtns from '../pages/authenticate/components/SocialLoginBtns.vue';
export default {
  props: {
    redirectToLink: {
      type: String,
      default: null,
    },
  },
  components: { LoginForm, SocialLoginBtns, Button },
};
